<template>
    <modal class="panel-dashboard p-0" :show="show" :showContent="showContent" :pageTitle="panelTitle" @close="closeModal" :closeBtn="closeBtn" :position="position" :size="size">
        <template v-slot:content>
            <div class="ct-aside-control-item">
                <div class="ct-aside-control-header">
                    <div class="title d-flex justify-content-between align-items-center w-100">
                        {{ panelTitle }}
                    </div>
                </div>
                <div class="ct-aside-control-body">
                    <div class="row no-gutters">
                        <div class="col">
                            <div class="row no-gutters">
                                <div class="col-6 mb-3" v-for="(module, idx) in modules" :key="`module-side-${idx}`">
                                    <div class="card module-side" :class="{'ml-1 mr-2': idx%2==0,'mr-1 ml-2': idx%2==1}">
                                        <div class="card-header" :class="{'h-100': !isCurrentRoute(module.route)}">
                                            <template v-if="module.route">
                                                <router-link class="" :to="{ name: module.route, params: { appCode: formatRouteAppCode(module.code) } }" v-on:click.native="closeModal">
                                                    <div class="media h-100">
                                                        <img v-if="module.icon" :src="module.icon" class="" :alt="module.name">
                                                        <div class="media-body">
                                                            <span v-html="labelModule(module.name)"></span>
                                                        </div>
                                                    </div>
                                                </router-link>
                                            </template>
                                            <template v-else-if="module.url">
                                                <a :href="module.url" target="_blank">
                                                    <div class="media h-100">
                                                        <img v-if="module.icon" :src="module.icon" class="" :alt="module.name">
                                                        <div class="media-body">
                                                            <span v-html="labelModule(module.name)"></span>
                                                        </div>
                                                    </div>
                                                </a>
                                            </template>
                                        </div>
                                        <div class="card-body" v-if="isCurrentRoute(module.route)">
                                            <p class="card-text">{{ titleHere }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script type="text/javascript">
    import GlobalMixin from '@/app/shared/mixins/global';
    import { formatRouteAppCode } from '@config/utils';

    export default {
        name: 'PanelDashboard',
        mixins: [
            GlobalMixin,
        ],
        components: {
            Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
        },
        props: {
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            panelTitle: {
                type: String,
                required: false,
                default: 'Dashboard'
            },
            closeBtn: {
                type: Boolean,
                default: true
            },
            position: {
                type: String,
                default: 'right',
            },
            size: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                idPanel: 'dashboard',
                titleHere: 'Está aqui',
                loaded: true,
                showContent: true,
                isDemo: false,
            }
        },
        mounted() {
            this.initialize();
        },
        computed: {
            show() {
                return this.$store.getters[`${this.moduleCode}/getPanel`](this.idPanel)?.show;
            },
            allModules() {
                return this.$store.getters[`${this.moduleCode}/getModules`];
            },
            modules() {
                let allModules = JSON.parse(JSON.stringify(this.allModules));
                let items = allModules.filter(m => {
                    if(!this.isDemo){
                        if(!m.active) return false;

                        return !m.acl || this.checkPermission(m, 'acl');
                    }
                    return true;
                });

                items.map(m => {
                    m.notifications = {};
                });
                return items;
            },
            currentRouteName() {
                return this.$route.name;
            },
        },
        methods: {
            initialize: function() {
                if(this.loaded){
                    return;
                }
            },
            closeModal: function() {
                this.$store.dispatch(`${this.moduleCode}/closePanel`, this.idPanel);
                this.$emit('close');
            },
            reset() {
                // Object.assign(this.$data, this.$options.data());
                this.loaded=false;
            },
            isCurrentRoute: function(route) {
                return route ? route.split(".")[0].toLowerCase() == this.currentRouteName.split(".")[0].toLowerCase() : false;
            },
            labelModule: function(name) {
                return name.split('-').map(item => item.trim()).join('<br>');
            },
            processNotification: function(num) {
                return num>0?`Tem ${num} notificações`:'Não tem notificações';
            },
            formatRouteAppCode: function(code) {
                return formatRouteAppCode(code);
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
